import * as tslib_1 from "tslib";
import { Exclude } from 'class-transformer';
import { DimensionSelectorResultDto } from './dimension-selector-result-dto';
export class DimensionOptionCodeRawDto {
    getDimension(results) {
        return results.find((r) => r.code === this.dimensionCode);
    }
}
tslib_1.__decorate([
    Exclude(),
    tslib_1.__metadata("design:type", DimensionSelectorResultDto)
], DimensionOptionCodeRawDto.prototype, "dimension", void 0);
